export default "__VITE_ASSET__0b63219c__"